import React from 'react'

import { Airdrops } from 'src/components/AdminPanel/fund/airdrops'

export const AirdropsPage = () => <Airdrops />
